/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
*/
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
 
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getFriendlyErrorMessage(error: unknown, context: string): string {
    let rawMessage = 'حدث خطأ غير معروف.';
    if (error instanceof Error) {
        rawMessage = error.message;
    } else if (typeof error === 'string') {
        rawMessage = error;
    } else if (error) {
        rawMessage = String(error);
    }

    // معالجة أخطاء محددة
    if (rawMessage.includes("النموذج لم يعد صورة")) {
        return "فشل في معالجة الصورة. يرجى المحاولة مرة أخرى أو استخدام صورة أخرى.";
    }
    
    if (rawMessage.includes("فشل في إنشاء الصورة")) {
        return "فشل في إنشاء الصورة. يرجى المحاولة مرة أخرى أو استخدام صورة أخرى.";
    }
    
    if (rawMessage.includes("Request was blocked")) {
        return "تم رفض الطلب لأسباب أمنية. يرجى المحاولة بصورة أخرى.";
    }
    
    if (rawMessage.includes("API_KEY")) {
        return "مفتاح API غير صحيح أو مفقود. يرجى التحقق من الإعدادات.";
    }
    
    if (rawMessage.includes("Unsupported MIME type")) {
        try {
            const errorJson = JSON.parse(rawMessage);
            const nestedMessage = errorJson?.error?.message;
            if (nestedMessage && nestedMessage.includes("Unsupported MIME type")) {
                const mimeType = nestedMessage.split(': ')[1] || 'unsupported';
                return `نوع الملف '${mimeType}' غير مدعوم. الرجاء استخدام تنسيق مثل PNG, JPEG, أو WEBP.`;
            }
        } catch (e) {
            // Not a JSON string, but contains the text. Fallthrough to generic message.
        }
        return `تنسيق الملف غير مدعوم. الرجاء تحميل صورة بتنسيق مثل PNG, JPEG, أو WEBP.`;
    }
    
    if (rawMessage.includes("safety")) {
        return "تم رفض الطلب لأسباب أمنية. يرجى المحاولة بصورة أخرى.";
    }
    
    if (rawMessage.includes("network") || rawMessage.includes("fetch")) {
        return "خطأ في الاتصال. يرجى التحقق من اتصال الإنترنت والمحاولة مرة أخرى.";
    }
    
    return `${context}. ${rawMessage}`;
}